export const DELIVERY_INFO_REDUCER_NAME = 'deliveryInfo'
export const DELIVERY_DATES_BY_PRODUCTS_REDUCER_NAME =
  'deliveryDatesForProducts'
export const ALL_DELIVERY_DATES_REDUCER_NAME = 'allDeliveryDates'
export const USER_DELIVERIES_REDUCER_NAME = 'userDeliveries'
